<template>
    <button type="button" @click="click">
        <slot />
    </button>
</template>

<script>
    import ModalManager from '../services/modalManager';

    export default {
        props: {
            value: {
                type: [Number, String],
                default: null,
            },

            url: {
                type: String,
                required: true,
            },
        },

        methods: {
            click() {
                ModalManager.openModal(this.url)
                    .then((data) => {
                        if (data !== null) {
                            this.$emit('input', data.id);
                            this.$emit('refresh');
                        }
                    });
            },
        },
    };
</script>
